import { ApiBlockListModelItemsItem, AttatchmentElementElementModel } from '@shared/integrations/umbraco-taf-delivery-api/models';

interface IBookingObjectAttachments {
    attachments: ApiBlockListModelItemsItem[];
}
// @ts-ignore
const BookingObjectAttachments = ({ attachments }: IBookingObjectAttachments) => {
    return (
        <section className='d-flex flex-column gap-3'>
            {attachments.map((p, key) => {
                const attachment = p.content as AttatchmentElementElementModel;
                const file = attachment?.properties?.attatchment ? attachment?.properties?.attatchment[0] : null;

                return (
                    <div
                        key={key}
                        className='d-flex gap-1 border rounded p-2 relative'
                    >
                        <span className={`mdi mr-1 mdi-paperclip font-size-xxl`}></span>
                        <div>
                            <h3 className='h5 mb-1'>{attachment.properties?.heading}</h3>
                            <span>{attachment.properties?.description}</span>
                            {file && file.url ? (
                                <a
                                    className='stretched-link stretched-link--hiden'
                                    href={file.url}
                                    target='_blank'
                                    rel='noreferrer'
                                />
                            ) : null}
                        </div>
                    </div>
                );
            })}
        </section>
    );
};

export default BookingObjectAttachments;
